<div class="d-flex align-items-center justify-content-between">
  <h4 class="title ms-2">Promocodes</h4>
</div>
<div class="create-field" [ngStyle]="{
    height: ((promoCodeGroup.get('name').invalid && promoCodeGroup.get('name').touched)
    || (promoCodeGroup.get('quantity').invalid && promoCodeGroup.get('quantity').touched))  ? '250px' : '220px'
  }">
  <div class="hashtag-form-and-buttons-container">
    <app-filled-form-field class="hashtag-input-form"
                           [label]="'Name *'"
                           [isSuffixIconVisible]="true"
                           [formControl]="promoCodeGroup.get('name')"
                           [isControlInvalid]="!promoCodeGroup.get('name').valid && promoCodeGroup.get('name').touched"
                           [errorMessage]="'This field is required'"
                           icon="cached"
                           (autoGenerated)="onAutoGenerationUsed()">
    </app-filled-form-field>
    <div class="buttons-side">
      <button mat-button class="cancel-btn" (click)="resetForm()">Undo</button>
      <button mat-button
              [ngClass]="promoCodeGroup.invalid ? 'save-btn-disabled' : 'save-btn'"
              [disabled]="promoCodeGroup.invalid"
              (click)="createPromoCode()">
        <div class="admin-add-icon-and-text">
          <mat-icon class="add-icon-hashtag">add</mat-icon>
          Create
        </div>
      </button>
    </div>
  </div>
  <div class="under-forms-container">
    <div class="qty-and-expiry-date-container">
      <app-filled-form-field
                             [label]="'Qty *'"
                             [formControl]="promoCodeGroup.get('quantity')"
                             [isControlInvalid]="!promoCodeGroup.get('quantity').valid && promoCodeGroup.get('quantity').touched"
                             [errorMessage]="QTY_ERROR_MESSAGE"
                             (input)="onQuantityInput($event)">
      </app-filled-form-field>
      <mat-form-field appearance="fill" class="width-60">
        <mat-label>Expiry Date </mat-label>
        <input matInput
               [matDatepicker]="picker"
               [formControl]="promoCodeGroup.get('expiryDate')"
               placeholder="Select a date">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>
    <app-filled-form-field
                           [label]="'Discount *'"
                           [isSuffixIconVisible]="true"
                           [formControl]="promoCodeGroup.get('discountPercent')"
                           [isControlInvalid]="!promoCodeGroup.get('discountPercent').valid && promoCodeGroup.get('discountPercent').touched"
                           [errorMessage]="DISCOUNT_ERROR_MESSAGE"
                           (input)="onDiscountInput($event)"
                           icon="percent">
    </app-filled-form-field>

    <mat-form-field class="new-style" appearance="fill" (click)="$event.stopPropagation()">
      <mat-select placeholder="Type *"   [formControl]="promoCodeGroup.get('type')">
        <mat-option [value]="PromoCodeType.SUBSCRIPTION">
          {{ PromoCodeType.SUBSCRIPTION | titlecase }}
        </mat-option>
        <mat-option [value]="PromoCodeType.PRODUCT">
          {{ PromoCodeType.PRODUCT | titlecase }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="promoCodeGroup.get('type')?.hasError('required') && promoCodeGroup.get('type')?.touched">
        Select Type
      </mat-error>
    </mat-form-field>
  </div>
</div>
<div class="hashtags-container">
  <div class="hashtag-list-collection">
    <div class="hashtag-content-list">
      <div class="hashtags-info-container hashtag-info-text">
        Promocode info
      </div>
      <div class="line-container"></div>
      <p-table class="w-100 mt-1 transaction-table table-bordered" [value]="promoCodes"
               [tableStyle]="{'min-width': '60rem'}"
               [paginator]="false"
               [rowHover]="true"
               [resizableColumns]="true"
               [sortOrder]="-1">
        <ng-template pTemplate="header">
          <tr>
            <th class="bg-light-white">#</th>
            <th width="25%" class="bg-light-white">Username</th>
            <th class="bg-light-white">Limit</th>
            <th  class="bg-light-white">Discount</th>
            <th class="bg-light-white">End Date</th>
            <th  class="bg-light-white">Type</th>
            <th  class="bg-light-white">Used Count</th>
            <th  class="bg-light-white">Action</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
          <tr>
            <td>
              {{ (promoCodePage * size) + rowIndex + 1 }}
            </td>
            <td>
              <div class="hashtag-name-container">
                <div class="hashtag-name-text-container">
                  <div class="promo-code-scroll-container">
                    {{ row.code }} <img class="cursor-pointer ms-2" src="assets/svg/copy.svg"  (click)="copyCode(row)" alt="Copy code">
                  </div>
                </div>
              </div>
            </td>
            <td>
              {{ row.quantity }}
            </td>
            <td>
              {{ row.discount }} %
            </td>
            <td>
              {{ row.expirationDate | date: 'dd/MM/yyyy' }}
            </td>
            <td>
              {{ row.type | titlecase }}
            </td>
            <td>
              {{ row.quantityLimit }}
            </td>
            <td>
              <div class="list-for-edit">
                <img src="assets/svg/deleteHashtagButton.svg" (click)="deletePromoCode(row.id)">
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="7" class="no-data">No data to display.</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="paginatorleft">
          {{ promoCodes.length }} total
        </ng-template>
      </p-table>
      <div class="pagination">
        <a (click)="goToPage(promoCodePage - 1)" [class.disabled]="promoCodePage === 0">&laquo;</a>
        <a *ngFor="let page of getPageNumbers()"
           (click)="goToPage(page - 1)"
           [class.active]="promoCodePage === (page - 1)">
          {{ page }}
        </a>
        <a (click)="goToPage(promoCodePage + 1)" [class.disabled]="promoCodePage === totalPages - 1">&raquo;</a>
      </div>
    </div>
  </div>
</div>
